import { render, staticRenderFns } from "./PersonaTheVoiceOfGloSection.vue?vue&type=template&id=64459856"
import script from "./PersonaTheVoiceOfGloSection.vue?vue&type=script&lang=ts"
export * from "./PersonaTheVoiceOfGloSection.vue?vue&type=script&lang=ts"
import style0 from "./PersonaTheVoiceOfGloSection.vue?vue&type=style&index=0&id=64459856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports